import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

/**
 * Check conditions to show MCP Server dropdown.
 */
export const isShowMCPServerDropdown = ({corporationDetail, selectedCorporationDetail, serverList}) => {
    if (Utils.isEmptyObject(corporationDetail)) return false;
    if (Utils.isEmptyObject(selectedCorporationDetail)) return false;
    if (Utils.isEmptyArray(serverList)) return false;

    const currentCorporationContractType =
        corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM;

    //selected corporation setting MCP Server
    const selectedCorporationSetting = Utils.convertJSONDataToObject(
        selectedCorporationDetail?.corporationSetting
    );
    const selectedCorporationLimitValue = selectedCorporationDetail?.limitValue;
    const isRootOnMCPServerOfSelectedCorporation =
        selectedCorporationLimitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;
    const usingMCPServerOfSelectedCorporation =
        selectedCorporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;

    //current corporation setting MCP Server
    const currentCorporationSetting = Utils.convertJSONDataToObject(
        corporationDetail?.corporationSetting
    );
    const currentCorporationLimitValue = corporationDetail?.limitValue;
    const isRootOnMCPServerOfCurrentCorporation =
        currentCorporationLimitValue?.mcpServer === Constant.STATUS_SERVICE_PERMISSION.ON;
    const usingMCPServerOfCurrentCorporation =
        currentCorporationSetting?.usingMCPServer === Constant.STATUS_SERVICE_PERMISSION.ON;

    const hasMcpServerOptions = serverList.length > 0;

    let result = true;
    if (!currentCorporationContractType || !hasMcpServerOptions) {
        result = false;
    } else if (
        (!isRootOnMCPServerOfSelectedCorporation || !usingMCPServerOfSelectedCorporation) &&
        (!isRootOnMCPServerOfCurrentCorporation || !usingMCPServerOfCurrentCorporation)
    ) {
        result = false;
    }

    return result;
};

/**
 * Check conditions to show Kibana Analysis (分析機能) option in AI Chat.
 * Preconditions:
 *   - Corporation contract type must be PREMIUM
 *   - Project type must be GENERAL
 *   - 3-tier check of isShowKibanaAnalysisField
 */
export const isShowKibanaAnalysisOption = ({corporationDetail, projectInuseDetail}) => {
    if (corporationDetail?.contractType !== Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
        return false;
    }

    if (projectInuseDetail?.type !== Constant.PROJECT_TYPE.GENERAL) {
        return false;
    }

    return isShowKibanaAnalysisField({ corporationDetail, projectInuseDetail });
};

/**
 * Check conditions to show field_kibana_analysis (分析機能) on form / knowledge list / CSV (CR-297430).
 * Same 3-tier check as BE KibanaAnalysisService.isSdAutoKibanaAllowed:
 *   - PC-2: Root enabled logAnalysis for org (limitValue.logAnalysis === ON)
 *   - PC-3: Org Setting toggle usingKibanaAnalysis === ON
 *   - PC-4: Project toggle usingKibanaAnalysis === true
 */
export const isShowKibanaAnalysisField = ({corporationDetail, projectInuseDetail}) => {
    if (Utils.isEmptyObject(corporationDetail) || Utils.isEmptyObject(projectInuseDetail)) {
        return false;
    }

    const limitValue = corporationDetail?.limitValue || {};
    const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting) || {};
    const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting) || {};

    return (
        limitValue?.logAnalysis === Constant.STATUS_SERVICE_PERMISSION.ON &&
        corporationSetting?.usingKibanaAnalysis === Constant.STATUS_SERVICE_PERMISSION.ON &&
        projectSetting?.usingKibanaAnalysis === true
    );
};

export const handleToggleMcpServer = ({
    selectedServerId,
    selectedMcpServers = [],
    onMcpSelectionChange = () => {}
}) => {
    const currentIndex = selectedMcpServers.indexOf(selectedServerId);
    const newSelected = [...selectedMcpServers];

    if (currentIndex === -1) {
        newSelected.push(selectedServerId);
    } else {
        newSelected.splice(currentIndex, 1);
    }

    onMcpSelectionChange?.(newSelected);
};
